/* AdVille · correzioni FrancescaBi · 26/08/2026
   Disegna il riempimento della barra "spedizione gratuita". Prestige aggiorna
   da solo gli attributi threshold e total-price sull'elemento <free-shipping-bar>:
   qui li leggiamo e basta, senza toccare la logica del carrello. */
(function () {
  'use strict';

  function track(bar) {
    var t = bar.querySelector('.av-fsb-track');
    if (!t) {
      t = document.createElement('div');
      t.className = 'av-fsb-track';
      t.innerHTML = '<div class="av-fsb-fill"></div>';
      bar.appendChild(t);
    }
    return t;
  }

  function draw(bar) {
    try {
      var threshold = parseFloat(bar.getAttribute('threshold'));
      var total = parseFloat(bar.getAttribute('total-price'));
      if (!isFinite(threshold) || threshold <= 0 || !isFinite(total)) return;
      var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
      var t = track(bar);
      t.setAttribute('data-reached', pct >= 100 ? 'true' : 'false');
      t.querySelector('.av-fsb-fill').style.width = pct.toFixed(1) + '%';
    } catch (e) { /* la barra e' un di piu': non deve mai rompere il carrello */ }
  }

  function watch(bar) {
    if (bar.__avWatched) return;
    bar.__avWatched = true;
    draw(bar);
    try {
      new MutationObserver(function () { draw(bar); })
        .observe(bar, { attributes: true, attributeFilter: ['total-price', 'threshold'] });
    } catch (e) { /* niente */ }
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(watch);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('cart:change', function () { setTimeout(scan, 60); });
  // il cassetto del carrello viene ridisegnato: guardiamo l'intera pagina
  try {
    new MutationObserver(function () { scan(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* niente */ }
  scan();
})();

/* Il bottone "Aggiungi al carrello" della sezione racconto sotto la scheda.
   Non duplica la logica del carrello: preme il bottone vero del tema, cosi'
   la variante scelta e le sue verifiche restano quelle di Prestige.
   Se quel bottone non c'e' o e' spento (capo esaurito), riporta al buy box. */
(function () {
  'use strict';

  function vero() {
    var bs = document.querySelectorAll('.product-info button[name="add"], product-form button[type="submit"]');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], r = b.getBoundingClientRect();
      if (!b.disabled && r.width > 40 && r.height > 20) return b;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var sezione = e.target.closest ? e.target.closest('[id$="__av_storia"]') : null;
    if (!sezione) return;
    var a = e.target.closest('a[href="#"], a[href$="#"]');
    if (!a) return;
    e.preventDefault();
    var b = vero();
    if (b) {
      b.click();
      return;
    }
    var box = document.querySelector('.product-info') || document.querySelector('[id$="__main"]');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
})();
